import { auth } from '@shared/config';
import { FirebaseUser } from '@shared/types';
import { authBreadcrumb, captureAuthError } from '@features/sentry-connect';
import { onAuthStateChanged } from 'firebase/auth';

export const getUser = () => {
  authBreadcrumb('getUser: subscribing to onAuthStateChanged', {
    hasCachedCurrentUser: Boolean(auth.currentUser),
    cachedUid: auth.currentUser?.uid ?? null,
  });
  return new Promise<FirebaseUser | null>((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(
      auth,
      user => {
        authBreadcrumb('getUser: onAuthStateChanged resolved', {
          hasUser: Boolean(user),
          uid: user?.uid ?? null,
          emailVerified: user?.emailVerified ?? null,
        });
        resolve(user);
        unsubscribe();
      },
      error => {
        captureAuthError(error, 'getUser:onAuthStateChanged', {
          message: error instanceof Error ? error.message : String(error),
        });
        reject(error);
        unsubscribe();
      }
    );
  });
};
